export interface SharedMessage {
  action: 'get' | 'set';
  store: string;
  key: string;
  value: any;
  event?: string;
  data?: any;
}

type Listener = (data: SharedMessage) => void;
type Listeners = Record<string, Array<Listener>>;

export class PostMessageClient {
  private readonly store: string;
  private readonly frame: HTMLIFrameElement;
  private isStoreReady = false;
  private readonly url: URL;
  private listeners: Listeners = {};

  constructor(name: string, url: string) {
    const ID = name.toLowerCase().replace(' ', '-');
    this.store = ID;
    this.url = new URL(url);

    const frame = document.createElement('iframe');
    frame.setAttribute('id', ID);
    frame.setAttribute('src', url);
    frame.setAttribute('width', '0');
    frame.setAttribute('height', '0');
    frame.setAttribute('visibility', 'hidden');

    frame.style.display = 'none';
    frame.onload = () => (this.isStoreReady = true);
    document.body.appendChild(frame);
    this.frame = frame;
    window.addEventListener('message', this.onMessage.bind(this)); // Receive messages from the iframe and call registered callbacks for events.
  }

  set(key: string, value: string): void {
    const data: SharedMessage = {
      action: 'set',
      store: this.store,
      key,
      value,
    };

    if (this.isStoreReady) {
      this.postMessage(data);
      return;
    }

    this.frame.addEventListener('load', () => this.postMessage(data || null));
  }

  private postMessage(data: SharedMessage): void {
    this.frame.contentWindow?.postMessage(data, this.url.origin);
  }

  public on(event: string, callback: Listener): void {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push(callback);
  }

  private onMessage(event: MessageEvent): void {
    if (!event || event.origin !== 'https://embarkvet.com') {
      return;
    }

    const message: SharedMessage = event.data;

    const eventName = message.event;
    if (!eventName) {
      return;
    }

    const callbacks = this.listeners[eventName];

    if (!callbacks || !callbacks.length) {
      return;
    }

    callbacks.forEach((callback) => callback(message));
  }
}
